import { useEffect, useState, useRef } from "react";
import useAxios from "../../../../MainComponents/Hooks/useAxios";

export const BunnyVideo = ({ src, history_id }) => {
  const iframeRef = useRef(null);
  const playerRef = useRef(null);
  const [watchTime, setWatchTime] = useState(0);

  const [submitDecreaseWatch, setSubmitDecreaseWatch] = useState({
    flag: "",
    dependency: false,
    data: {},
  });

  const [decreaseWatchSuccess, decreaseWatchErrors, decreaseloading] = useAxios(
    process.env.REACT_APP_STUDENT_DECREASE_WATCHE_IN_COURSE_API,
    "POST",
    submitDecreaseWatch.flag,
    submitDecreaseWatch.dependency,
    submitDecreaseWatch.data
  );

  useEffect(() => {
    // Check if PlayerJS is already available on window
    if (window.playerjs) {
      // Initialize PlayerJS on the iframe element
      playerRef.current = new window.playerjs.Player(iframeRef.current);

      // Event listeners for player actions
      playerRef.current.on("ready", () => {
        console.log("Player is ready");
      });

      playerRef.current.on("play", () => {
        console.log("Video playing");
      });

      playerRef.current.on("pause", () => {
        console.log("Video paused");
      });

      playerRef.current.on("ended", () => {
        console.log("Video ended");
        setWatchTime(0);
      });

      playerRef.current.on("timeupdate", (data) => {
        setWatchTime(data.seconds);
      });
    }

    setWatchTime(0);
  }, [src]);

  useEffect(() => {
    if (watchTime >= 1199.9 && watchTime <= 1200.1) {
      setSubmitDecreaseWatch({
        flag: "deleteQuestion",
        dependency: !submitDecreaseWatch.dependency,
        data: { id: history_id },
      });
    }
  }, [watchTime, history_id]);

  return (
    <iframe
      ref={iframeRef}
      id="bunnyPlayer"
      src={src}
      width="100%"
      height="100%"
      title="Bunny Video Player"
      frameBorder="0"
      allow="accelerometer; fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    ></iframe>
  );
};
